import React from "react";
import { FileText, AlertCircle } from "lucide-react";

/**
 * About Event Section Component
 * Text area for event description
 */
const AboutEventSection = ({ value = "", onChange, className = "" }) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={className}>
      <div className="p-4 bg-white rounded-xl border border-gray-100 shadow-sm sm:rounded-2xl">
        <div className="flex items-center mb-4 space-x-2">
          <FileText className="w-5 h-5 text-purple-600" />
          <h3 className="text-lg font-bold text-gray-900">About This Event</h3>
        </div>

        <p className="mb-4 text-xs text-gray-600">
          Provide a detailed description of your event. This will help attendees
          understand what to expect.
        </p>

        <div>
          <textarea
            value={value}
            onChange={handleChange}
            placeholder="Describe your event in detail. Include information about what attendees can expect, special features, highlights, and any other relevant details..."
            rows={8}
            className="w-full px-4 py-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all bg-gray-50 focus:bg-white resize-y"
          />
          <div className="flex justify-between items-center mt-2">
            <p className="text-xs text-gray-500">
              {value.length} characters
            </p>
            <p className="text-xs text-gray-500">
              Be descriptive to attract more attendees
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutEventSection;

